module.exports = __webpack_public_path__ + "static/media/calendar-cog.524cdce3.svg";